import { createFileRoute } from "@tanstack/react-router";
import CommsBuildingSettings from "@/components/building_admin/building_admin_settings/comms";
import { buildingOptions } from "@/api";
import { SettingsSubPage } from "@/components/building_admin/building_admin_settings/SettingsSubPage";
import { useWelcomeCommunicationAccess } from "@/hooks/useWelcomeCommunicationAccess";
import { useRouterStore } from "@/store/zustandStore";

const PageComponent = () => {
  const { hasCommunication } = useWelcomeCommunicationAccess(true);
  const card = {
    icon: "campaign",
    value: "communication",
    label: "Welcome Communication",
    enabled: hasCommunication,
    to: "/building/settings/communication",
    descriptionKey: "PAGES.BUILDING_SETTINGS.MODULE_DESCRIPTIONS.COMMUNICATION",
  };
  return (
    <SettingsSubPage
      cardOptions={card}
      PageComponent={CommsBuildingSettings}
      label="Communication"
      path="/building/settings/communication"
    />
  );
};

export const Route = createFileRoute(
  "/_portal/building/settings/communication",
)({
  component: PageComponent,
  loader: () => {
    const { queryClient } = useRouterStore.getState();
    if (!queryClient) return;
    queryClient.ensureQueryData(buildingOptions);
  },
});
